import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Course } from './model/course.model';
import { Action, createReducer, on } from '@ngrx/store';
import { CourseActions } from './course.actions';

export const courseFeatureKey = 'course';

export const courseAdapter = createEntityAdapter<Course>();

export interface State extends EntityState<Course> {}

export const initialState: State = courseAdapter.getInitialState({});

const courseReducer = createReducer(
    initialState,
    on(CourseActions.loadCoursesSuccess, (state, { courses }) => courseAdapter.addMany(courses, state)),
    on(CourseActions.createCourseSuccess, (state, { course }) => courseAdapter.addOne(course, state)),
    on(CourseActions.updateCourseSuccess, (state, { course }) => courseAdapter.updateOne({ id: course.id!, changes: course }, state)),
    on(CourseActions.changeActiveStatusSuccess, (state, { course }) => courseAdapter.updateOne({ id: course.id!, changes: { active: !course.active } }, state)),
    on(CourseActions.deleteCourseSuccess, (state, { course }) => courseAdapter.removeOne(course.id!, state))
);

export function reducer(state: State | undefined, action: Action) {
    return courseReducer(state, action);
}
